import { VHeaders } from '@/models/pagedlistmodel';

export function getTimelineHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'searchVehicleLocation.timelineGridHeaders.enteredStepOn'
      ) as string,
      value: 'entryTime',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'searchVehicleLocation.timelineGridHeaders.exitedStepOn'
      ) as string,
      value: 'exitTime',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'searchVehicleLocation.timelineGridHeaders.step'
      ) as string,
      value: 'reviveStepName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'searchVehicleLocation.timelineGridHeaders.timeInStep'
      ) as string,
      value: 'elapsedTime',
    },
  ];
}

export function getHeaders(vm: any): VHeaders[] {
  return [
        {
            text:  vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.RFID') as string,
            align: 'left',
            value: 'rfidTag',
            sortable: true,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.store') as string,
            align: 'left',
            value: 'storeName',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.stock') as string,
            align: 'left',
            value: 'stockNumber',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.vinNumber') as string,
            align: 'left',
            value: 'registrationJson.vin',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.userName') as string,
            align: 'left',
            value: 'createdBy',
            sortable: false,
            filters: [(val) => {
                return val && val !== 'N/A' ? val : ' ';
            }],
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.year') as string,
            align: 'left',
            value: 'registrationJson.year',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.make') as string,
            align: 'left',
            value: 'registrationJson.make',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.model') as string,
            align: 'left',
            value: 'registrationJson.model',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.registerDateTime') as string,
            align: 'left',
            value: 'createdAt',
            fieldType: 'date',
            format: 'LLL',
            sortable: false,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.ReviveStatus') as string,
            align: 'left',
            value: 'reviveStatus',
            sortable: false,
            filters: [(val) => {
                return val && val !== 'N/A' ? val : ' ';
            }],
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.vehicleLocationGridHeaders.action') as string,
            align: 'center',
            isNotDataProp: true,
            sortable: false,
        },
    ];
    }
export function getAttachmentHeaders(vm: any): VHeaders[] {
  return [
        {
            text: '',
            value: 'selected',
            align: 'left',
            sortable: false,
            fieldType: 'checkbox',
            header: {
                type: 'checkbox',
            },
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.attachmentGridHeaders.vIN') as string,
            align: 'left',
            value: 'vin',
            sortable: true,
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.attachmentGridHeaders.comment') as string,
            align: 'left',
            value: 'comment',
            sortable: true,
            filters: [(val) => {
                return val && val !== 'N/A' ? val : ' ';
            }],
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.attachmentGridHeaders.createdAt') as string,
            align: 'left',
            value: 'createdAt',
            sortable: true,
            fieldType: 'date',
            format: 'LLL',
        },
        {
            text: vm.$parent.$t('searchVehicleLocation.attachmentGridHeaders.action') as string,
            align: 'center',
            isNotDataProp: true,
            sortable: false,
        },
    ];
}
